import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, filter, startWith, switchMap } from 'rxjs/operators';
import { Client, MedicareGEO } from 'src/app/models/client.model';
import { ClientServicesService } from 'src/app/services/admin/client-services.service';
import { SnackService } from 'src/app/services/snack.service';

@Component({
  selector: 'app-search-medicare-geo',
  templateUrl: './search-medicare-geo.component.html',
  styleUrls: ['./search-medicare-geo.component.scss'],
})
export class SearchMedicareGeoComponent implements OnInit, OnChanges {
  @Input() client: Client;
  filteredOptions: MedicareGEO[] = [];
  searchInput: UntypedFormControl = new UntypedFormControl();

  constructor(private clientService: ClientServicesService, private snackBarService: SnackService) {}

  ngOnInit(): void {
    this.setFilteredOptionToSearch();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['client']) {
      if (this.client.medicare_geo) {
        this.searchInput.setValue(this.client.medicare_geo);
      } else {
        this.searchInput.setValue('');
      }
    }
  }

  setFilteredOptionToSearch(): void {
    this.searchInput.valueChanges
      .pipe(
        startWith(''),
        filter((text) => !!text && text.length > 0),
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((value: string) => this.clientService.filterMedicareGEO(value.toUpperCase()))
      )
      .subscribe((res) => {
        this.filteredOptions = res;
      });
  }

  getOptionText(option: MedicareGEO): string {
    return option ? `${option.state} (${option.medicare_administrative_contractor}) -  ${option.locality_number}` : '';
  }

  save(): void {
    const selectedOption = this.filteredOptions.find((option) => option.id === this.searchInput.value.id);
    const { id, ...rest } = selectedOption;
    const client = {
      medicare_geo: rest,
    };
    this.clientService.updateClientService(this.client.client_id, client).subscribe(
      (data) => {
        this.snackBarService.genericSnackBar('Medicare GEO saved successfully', ['success-snackbar'], 5000);
      },
      (error) => {
        console.error(error);
        this.snackBarService.genericSnackBar('An error occurred updating client', ['error-snackbar'], 5000);
      }
    );
  }
}
